import { render, staticRenderFns } from "./serviceWidget.vue?vue&type=template&id=55a74d46"
import script from "./serviceWidget.vue?vue&type=script&lang=js"
export * from "./serviceWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports